import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import EnglishFile from "../../languages/en/translation.json";
import HindiFile from "../../languages/hi/translation.json";
import SpanishFile from "../../languages/es/translation.json";
import ChineseFile from "../../languages/zh-CN/translation.json";
import ArabicFile from "../../languages/ar/translation.json";
import FrenchFile from "../../languages/fr/translation.json";
import PortugueseFile from "../../languages/pt/translation.json";
import GermanFile from "../../languages/de/translation.json";
import JapaneseFile from "../../languages/ja/translation.json";
import RussianFile from "../../languages/ru/translation.json";
import IndonesianFile from "../../languages/id/translation.json";
import BengaliFile from "../../languages/bn/translation.json";
import UrduFile from "../../languages/ur/translation.json";
import TeluguFile from "../../languages/te/translation.json";
import TamilFile from "../../languages/ta/translation.json";

const DEFAULT_LANGUAGE = "en";
const LANGUAGE_STORAGE_KEY = "i18nextLng";

const getInitialLanguage = () => {
  if (typeof window === "undefined") return DEFAULT_LANGUAGE;

  try {
    return (
      window.sessionStorage.getItem(LANGUAGE_STORAGE_KEY) || DEFAULT_LANGUAGE
    );
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    debug: true,
    detection: {
      order: ["sessionStorage", "navigator"],
      caches: ["sessionStorage"],
      lookupSessionStorage: "i18nextLng",
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: EnglishFile,
      },
      hi: {
        translation: HindiFile,
      },
      es: {
        translation: SpanishFile,
      },
      "zh-CN": {
        translation: ChineseFile,
      },
      ar: {
        translation: ArabicFile,
      },
      fr: {
        translation: FrenchFile,
      },
      pt: {
        translation: PortugueseFile,
      },
      de: {
        translation: GermanFile,
      },
      ja: {
        translation: JapaneseFile,
      },
      ru: {
        translation: RussianFile,
      },
      id: {
        translation: IndonesianFile,
      },
      bn: {
        translation: BengaliFile,
      },
      ur: {
        translation: UrduFile,
      },
      te: {
        translation: TeluguFile,
      },
      ta: {
        translation: TamilFile,
      },
    },
  });

export default i18n;
